
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { requiredValidationRule } from '@/helpers/validationRules';
import { ServiceCodeItem } from '@/store/modules/staticData/staticDataTypes';
import NoDataSelectItem from '@/components/selectItems/NoDataSelectItem.vue';
import CommonSelectItem from '@/components/selectItems/CommonSelectItem.vue';
import store from '@/store';

@Component({
  components: {
    NoDataSelectItem,
    CommonSelectItem,
  },
})
export default class ServiceCodesServiceAutocompleteField extends Vue {
  @Prop(String) public value: string;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  @Watch('value', { immediate: true })
  private watchValue(value: string) {
    // console.debug('watchValue', value);
    this.fieldValue = value;
  }

  @Watch('fieldValue')
  private watchFieldValue(fieldValue: string | null) {
    // console.debug('watchFieldValue', fieldValue);
    this.$emit('input', fieldValue || '');
  }

  public fieldValue: string | null = '';
  public items: ServiceCodeItem[] = [];

  private async created() {
    this.items = await store.getters['moduleStaticData/getAllStaticData'].serviceCodes;
  }

  public filter(item: ServiceCodeItem, queryText: string) {
    return (item.code + item.description).toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
  }

  public fieldValidationRules = [requiredValidationRule];
}
